<template>
  <div class="page-container">
    <!-- 上部分：标题 -->
    <div class="header-section">
      <h1 class="main-title">INTRODUCE</h1>
    </div>

    <!-- 中部分 -->
    <div class="middle-section">
      <div class="content-container">
        <div class="middle-content">
          <div
            class="image-section"
            :class="{ 'fade-up': isMiddleVisible }"
            ref="middleSection"
          >
            <img
              src="@/assets/imgsnew/page6-1.svg"
              alt="Company Team"
              class="team-image"
            />
          </div>
          <div class="text-content" :class="{ 'fade-up': isMiddleVisible }">
            <h2 class="section-title">COMPANY INTRODUCTION</h2>
            <div class="description">
              We are an outstanding and fully compliant global payment company.
              Upholding a firm commitment to security, compliance and stable
              operation, we provide a full range of global payment services. Our
              advanced technological infrastructure and well-trained team ensure
              that every single transaction can be processed with extreme
              caution and precision.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 下部分 -->
    <div class="bottom-section">
      <div class="content-container">
        <div class="bottom-content">
          <div class="image-section" :class="{ 'fade-up': isBottomVisible }">
            <img
              src="@/assets/imgsnew/page6-2.svg"
              alt="Building"
              class="building-image"
            />
          </div>
          <div
            class="text-content"
            :class="{ 'fade-up': isBottomVisible }"
            ref="bottomSection"
          >
            <h2 class="section-title">
              INTEGRITY, MUTUAL WIN,<br />PURSUIT OF EXCELLENCE
            </h2>
            <div class="description">
              Whether it is facilitating cross-border e-commerce payments or
              providing wealth services for various types of users, INSPAY is
              dedicated to meeting the diverse needs of global customers. We are
              constantly making unremitting efforts to strive to maintain a
              leading position in the continuously evolving payment industry,
              constructing strategic partnerships and implementing innovative
              solutions to enhance the overall payment experience. Trust EASY
              PAY and let us handle your requirements with integrity and
              excellence.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroducePage",
  data() {
    return {
      isMiddleVisible: false,
      isBottomVisible: false,
      middleObserver: null,
      bottomObserver: null,
    };
  },
  mounted() {
    this.setupObservers();
  },
  beforeUnmount() {
    // 清理观察器
    if (this.middleObserver) this.middleObserver.disconnect();
    if (this.bottomObserver) this.bottomObserver.disconnect();
  },
  methods: {
    setupObservers() {
      const options = {
        threshold: 0.2, // 当20%的内容可见时触发
      };

      this.middleObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isMiddleVisible = false;
            setTimeout(() => {
              this.isMiddleVisible = true;
            }, 100);
          } else {
            this.isMiddleVisible = false;
          }
        });
      }, options);

      this.bottomObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isBottomVisible = false;
            setTimeout(() => {
              this.isBottomVisible = true;
            }, 100);
          } else {
            this.isBottomVisible = false;
          }
        });
      }, options);

      // 开始观察
      if (this.$refs.middleSection) {
        this.middleObserver.observe(this.$refs.middleSection);
      }
      if (this.$refs.bottomSection) {
        this.bottomObserver.observe(this.$refs.bottomSection);
      }
    },
  },
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header-section {
  padding: 60px 0;
  text-align: center;
}

.main-title {
  font-size: 48px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.middle-section,
.bottom-section {
  padding: 60px 0;
}

.middle-content,
.bottom-content {
  display: flex;
  align-items: center;
  gap: 60px;
}

.image-section {
  flex: 1;
}

.team-image,
.building-image {
  width: 100%;
  height: auto;
  max-width: 600px;
}

.text-content {
  flex: 1;
}

.section-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 24px;
  line-height: 1.3;
}

.description {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

@media (max-width: 768px) {
  .header-section {
    padding: 30px 0;
  }

  .main-title {
    font-size: 28px;
  }

  .middle-content,
  .bottom-content {
    flex-direction: column;
    gap: 30px;
  }

  .image-section {
    width: 100%;
    order: 1;
  }

  .text-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 15px;
  }

  .section-title {
    order: 2;
    font-size: 20px;
    text-align: center;
    margin: 20px 0 15px;
  }

  .description {
    order: 3;
    font-size: 14px;
    text-align: center;
    line-height: 1.6;
    color: #666;
    margin: 0 auto;
    max-width: 335px;
  }

  .team-image,
  .building-image {
    max-width: 100%;
    width: 280px;
    margin: 0 auto;
    display: block;
  }

  /* 移除之前的 mobile-first 相关样式 */
  .mobile-first {
    order: unset;
  }

  /* 调整间距 */
  .image-section + .text-content {
    margin-top: 0;
  }

  /* 调整动画在移动端的表现 */
  .fade-up {
    animation-duration: 0.8s;
  }

  /* 减小移动端动画的位移距离 */
  @keyframes fadeUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .bottom-content {
    flex-direction: column;
    gap: 30px;
  }

  /* 在移动端调整底部内容的顺序 */
  .mobile-first {
    order: -1;
  }

  /* 调整间距 */
  .text-section {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .section-title {
    margin-bottom: 0; /* 移除原有的底部间距，使用gap控制 */
  }

  /* 调整图片和文字之间的间距 */
  .image-section + .text-section {
    margin-top: 20px;
  }

  /* 调整动画延迟以匹配新的顺序 */
  .middle-content .image-section.fade-up,
  .bottom-content .image-section.fade-up {
    animation-delay: 0.2s;
  }

  .middle-content .text-section.fade-up .section-title,
  .bottom-content .text-section.fade-up .section-title {
    animation-delay: 0.4s;
  }

  .middle-content .text-section.fade-up .description,
  .bottom-content .text-section.fade-up .description {
    animation-delay: 0.6s;
  }
}

/* 针对特小屏幕的额外优化 */
@media (max-width: 375px) {
  .main-title {
    font-size: 24px;
  }

  .team-image,
  .building-image {
    width: 240px;
  }

  .section-title {
    font-size: 18px;
  }

  .description {
    font-size: 13px;
    max-width: 300px;
  }
}

.fade-up {
  opacity: 0;
  transform: translateY(50px);
  animation: fadeUp 1s ease forwards;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 修改动画延迟的方式 */
.middle-content .image-section.fade-up {
  animation-delay: 0.2s;
}

.middle-content .text-section.fade-up {
  animation-delay: 0.4s;
}

.bottom-content .text-section.fade-up {
  animation-delay: 0.6s;
}

.bottom-content .image-section.fade-up {
  animation-delay: 0.8s;
}

/* 默认状态 */
.image-section,
.text-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}
</style>
